import { render, staticRenderFns } from "./ToggleButtonGroup.vue?vue&type=template&id=fbf72474&scoped=true&"
import script from "./ToggleButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ToggleButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./ToggleButtonGroup.vue?vue&type=style&index=0&id=fbf72474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf72474",
  null
  
)

export default component.exports